var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBenofity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1150.86 323.01",
    style: {
      enableBackground: "new 0 0 1150.86 323.01"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#004CEC;}\n\t.st2{fill:#BC0603;}\n\t.st3{stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st5{fill:url(#SVGID_1_);}\n\t.st6{fill:url(#SVGID_00000008856750843152786920000018233580161563709334_);}\n\t.st7{fill:url(#SVGID_00000109738296021874319690000015125669750557977771_);}\n\t.st8{fill:url(#SVGID_00000150794387788114209000000002042908817134479745_);}\n\t.st9{fill:url(#SVGID_00000131361555516291104650000011633011556577804197_);}\n\t.st10{fill:url(#SVGID_00000070801956588711885420000018154038016615604378_);}\n\t.st11{fill:url(#SVGID_00000147931621412204435040000001197133446608476060_);}\n\t.st12{fill:url(#SVGID_00000145038864390059257650000012948417957141125797_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -65.9044,
    y1: 123.4479,
    x2: 1121.2682,
    y2: 123.4479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C51FCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#801DD0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.09,175.12L24.91,24.76c1.86-12.07-2.79-13.61-12.99-11.45v-1.24C22.74,5.88,44.4,0,59.25,0 c17.63,0,24.44,5.88,21.04,27.54L51.52,202.97c-3.09,19.49-4.33,40.84,12.38,40.84c27.85,0,51.36-73.33,51.36-122.83 c0-12.69-3.4-24.44-11.45-24.44c-14.54,0-30.01,29.39-40.22,64.35l-2.79-0.93c18.56-62.5,40.84-80.44,66.52-80.44 c32.49,0,43.93,29.09,43.93,57.55c0,56.62-48.88,109.83-107.98,109.83C19.96,246.9-5.72,217.2,1.09,175.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178179319204786960260000008547089101093019780_",
    gradientUnits: "userSpaceOnUse",
    x1: -65.9044,
    y1: 163.0503,
    x2: 1121.2682,
    y2: 163.0503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C51FCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#801DD0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178179319204786960260000008547089101093019780_)"
    },
    d: "M174.78,180.07 c0-53.83,41.46-100.86,100.55-100.86c25.37,0.31,60.64,6.5,60.64,35.27c0,22.89-30.94,45.17-100.55,32.49l0.62-2.79 c36.51,2.79,54.14-23.52,54.14-42.7c0-11.14-4.33-19.18-14.85-19.18c-25.99,0-43.32,41.46-43.32,74.87 c0,34.35,16.71,51.67,41.77,52.29c16.4,0.31,38.36-4.64,52.29-23.83l2.17,0.93c-21.04,38.06-54.45,60.33-90.65,60.33 C201.39,246.9,174.78,221.22,174.78,180.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115509479594552452150000005853675577084640642_",
    gradientUnits: "userSpaceOnUse",
    x1: -65.9044,
    y1: 163.0503,
    x2: 1121.2682,
    y2: 163.0503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C51FCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#801DD0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115509479594552452150000005853675577084640642_)"
    },
    d: "M494.69,176.97 c-6.5,38.99-7.43,60.95,6.19,66.21v1.24c-8.04,1.55-15.47,2.16-22.89,2.16c-26.3,0-47.64-10.52-41.46-49.81l12.68-79.2 c2.48-14.54,1.86-21.66-5.88-21.66c-17.02,0-37.75,36.2-49.19,82.3c-5.26,21.35-13.92,59.71-3.4,64.97v1.24 c-10.83,1.55-19.49,2.47-26.92,2.47c-24.44,0-35.58-10.52-28.77-48.58l16.71-93.74c2.17-12.07-2.78-13.61-12.99-11.45v-1.23 c10.83-6.19,32.49-12.07,47.34-12.07c17.64,0,25.37,6.8,20.42,27.54l-17.02,69.92h1.24c20.73-78.9,51.05-98.08,78.89-98.08 c38.67,0,36.2,32.49,32.49,53.84L494.69,176.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075132953985734963020000011342709785540895138_",
    gradientUnits: "userSpaceOnUse",
    x1: -65.9044,
    y1: 163.0503,
    x2: 1121.2682,
    y2: 163.0503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C51FCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#801DD0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075132953985734963020000011342709785540895138_)"
    },
    d: "M681.85,149.44 c0,51.36-46.41,97.46-101.48,97.46c-44.24,0-74.87-29.39-74.87-70.23c0-52.9,45.48-97.46,101.17-97.46 C651.23,79.2,681.85,108.6,681.85,149.44z M625.24,117.57c0-18.25-3.4-35.27-18.87-35.27c-34.03,0-44.24,94.67-44.24,126.86 c0,18.25,3.4,34.65,18.57,34.65C615.03,243.8,625.24,154.08,625.24,117.57z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082364555526050813530000001992963756088850093_",
    gradientUnits: "userSpaceOnUse",
    x1: -65.9044,
    y1: 140.5844,
    x2: 1121.2682,
    y2: 140.5844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C51FCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#801DD0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082364555526050813530000001992963756088850093_)"
    },
    d: "M895.92,93.01h-13.21l0.59-2.94 c42.28,0,65.19-13.8,72.53-55.5h2.94l-9.4,55.5h20.55l-0.58,2.94h-20.26l-14.68,88.97c-6.46,39.94-6.75,56.38,9.1,61.37v1.18 c-10.57,1.47-17.62,2.05-24.67,2.05c-24.96,0-45.22-9.98-39.35-47.28L895.92,93.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155846138840654629530000015919001284026718644_",
    gradientUnits: "userSpaceOnUse",
    x1: -65.9044,
    y1: 198.0121,
    x2: 1121.2682,
    y2: 198.0121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C51FCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#801DD0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155846138840654629530000015919001284026718644_)"
    },
    d: "M971.73,278.76 c0-15.47,11.14-28.15,28.15-28.15c14.23,0,26.61,10.52,25.68,27.84c-8.05,1.24-15.47,8.36-15.47,17.32 c0,8.05,5.57,17.95,23.82,17.95c29.09,0,32.49-26.61,36.2-44.55l24.44-120.35h-1.24c-20.73,79.51-48.26,98.08-76.11,98.08 c-38.67,0-38.67-32.48-35.27-53.83l14.54-88.49c1.86-12.07-2.78-13.61-12.99-11.45v-1.23c10.83-6.19,32.49-12.07,47.34-12.07 c14.54,0,21.35,4.33,21.35,17.94c0,13.93-17.64,102.72-18.25,118.19c-0.31,8.97,3.4,14.23,9.59,14.23 c17.02,0,34.96-36.19,46.41-82.3c5.26-21.35,13.92-59.71,3.4-64.97v-1.24c10.83-1.55,19.49-2.48,26.92-2.48 c24.44,0,35.27,10.52,28.77,48.58l-19.8,116.02c-7.74,45.48-40.84,73.02-95.3,73.02C996.17,316.82,971.73,302.28,971.73,278.76z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167362451405000728350000001176616364109036456_",
    gradientUnits: "userSpaceOnUse",
    x1: -65.9044,
    y1: 164.5972,
    x2: 1121.2682,
    y2: 164.5972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C51FCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#801DD0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167362451405000728350000001176616364109036456_)"
    },
    d: "M626.78,286.81 c0-19.18,14.23-32.8,32.18-32.8c14.85,0,27.85,9.59,28.15,28.77c-12.38,2.79-20.11,10.21-20.11,20.73 c0,7.43,4.95,13.61,13.61,13.61c14.54,0,23.82-10.51,23.82-27.84c0-26.61-27.23-31.25-23.2-58.16l21.66-140.16h-17.02l0.62-3.09 h17.02c6.81-46.1,17.33-81.68,63.12-81.68c30.94,0,45.17,17.02,45.17,36.2c0,19.49-13.61,34.35-33.1,34.35 c-15.16,0-27.54-9.9-27.23-29.4c13.3-2.47,21.04-10.52,21.04-21.96c0-9.28-4.64-14.23-14.85-14.23 c-19.49,0-30.01,17.02-30.01,31.55c0,24.44,25.68,30.01,26.92,45.17h26.3l-0.62,3.09H758.9l-23.21,149.74 c-5.88,37.13-19.49,82.3-67.14,82.3C641.64,323.01,626.78,305.68,626.78,286.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048488190840335535850000012844414627145610933_",
    gradientUnits: "userSpaceOnUse",
    x1: -65.9044,
    y1: 127.6595,
    x2: 1121.2682,
    y2: 127.6595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C51FCE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#801DD0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048488190840335535850000012844414627145610933_)"
    },
    d: "M796.36,200.05l16.15-90.83 c2.13-11.89-2.44-13.41-12.8-11.28v-1.21c10.67-6.1,32.01-11.89,46.64-11.89c19.21,0,22.86,8.23,19.51,27.13l-12.19,68.89 c-6.71,38.4-7.32,59.74,6.1,64.93V247c-7.92,1.52-15.24,2.13-22.56,2.13C811.6,249.13,789.35,238.77,796.36,200.05z M825.93,72.03 c6.4-10.06,9.45-33.22,0.31-44.81c7.31-13.41,21.34-21.03,33.83-21.03c11.58,0,25.3,6.1,25.3,23.17 c0,23.78-27.43,44.81-58.83,43.59L825.93,72.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBenofity);
export default __webpack_public_path__ + "static/media/logo-benofity.2ffab1a3059416b8cd46d3f899556b5c.svg";
export { ForwardRef as ReactComponent };